import Icon from '../Icon';

const testimonials = [
    {
        text: 'Etiam sapien sagittis congue augue massa varius egestas ultrice varius magna undo tempus aliquet undo cursus suscipit cubilia laoreet augue.',
        name: 'Scott Boxer',
        title: '@scott_boxer',
        avatar: '/images/demo6/review-author-1.jpg',
    },
    {
        text: 'At sagittis congue augue egestas magna ipsum vitae a purus ipsum primis in cubilia laoreet augue egestas luctus and donec ultrice ligula magna.',
        name: 'Joel Peterson',
        title: 'Internet Surfer',
        avatar: '/images/demo6/review-author-2.jpg',
    },
    {
        text: 'Mauris donec magnis sapien sapien congue augue egestas et ultrice vitae purus diam integer congue magna ligula undo egestas magna suscipit.',
        name: 'Marisol19',
        title: '@marisol19',
        avatar: '/images/demo6/review-author-3.jpg',
    },
    {
        text: 'Mauris donec a magnis sapien etiam sapien undo congue augue pretium ligula lectus aenean ipsum magna undo mauris lectus laoreet tempor.',
        name: 'Leslie D.',
        title: 'Web Developer',
        avatar: '/images/demo6/review-author-4.jpg',
    },
];

const Demo6Reviews4 = () => {
    return (
        <section id="reviews" className="rel reviews-section division">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="section-title title-01 mb-60">
                            <h2 className="h2-md">Stories From Our Customers</h2>
                            <p className="p-xl">
                                Aliquam a augue suscipit, luctus neque purus ipsum neque dolor primis a libero tempus, blandit and cursus varius and magnis
                                sapien
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="reviews-4-holder">
                <div className="container">
                    <div className="row row-cols-1 row-cols-md-2">
                        {testimonials.map((testimonial) => (
                            <div className="col" key={testimonial.name}>
                                <div className="review-4">
                                    <div className="review-4-txt">
                                        <p className="p-lg">{testimonial.text}</p>
                                        <div className="author-data clearfix">
                                            <div className="review-avatar">
                                                <img src={testimonial.avatar} alt={`${testimonial.name} avatar`} />
                                            </div>
                                            <div className="review-author">
                                                <h6 className="h6-xl">{testimonial.name}</h6>
                                                <p className="p-md">{testimonial.title}</p>
                                                <div className="review-rating ico-15 yellow-color rating-stars" aria-label="Rated 4.5 out of 5">
                                                    {[...Array(4)].map((_, index) => (
                                                        <Icon key={`testimonial-${testimonial.name}-star-${index}`} symbol="★" decorative className="icon-star" />
                                                    ))}
                                                    <Icon symbol="½" decorative className="icon-star" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Reviews4;
